(function () {
  var SELECTOR = 'img.cardimg-deferred[data-srcset], img.cardimg-deferred[data-src]';

  function promote(img) {
    if (!img || img.dataset.cardimgDone) return;
    img.dataset.cardimgDone = '1';
    var ss = img.getAttribute('data-srcset');
    var sr = img.getAttribute('data-src');
    if (ss) {
      img.setAttribute('srcset', ss);
      img.removeAttribute('data-srcset');
    }
    if (sr) {
      img.setAttribute('src', sr);
      img.removeAttribute('data-src');
    }
    img.loading = 'eager';
    img.classList.remove('cardimg-deferred');
  }

  function promoteCard(el) {
    var card = el.closest('.card-wrapper, .card, .grid__item') || el;
    var imgs = card.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) promote(imgs[i]);
  }

  function promoteAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) promote(imgs[i]);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.cardinner_slide .slide_arrow, .card-dots, .card-dot');
    if (t) promoteCard(t);
  }, true);

  document.addEventListener('touchstart', function (e) {
    var t = e.target.closest && e.target.closest('.cardinner_slide');
    if (t) promoteCard(t);
  }, { passive: true, capture: true });

  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('.cardinner_slide');
    if (t) promoteCard(t);
  }, { passive: true, capture: true });

  window.pocoPromoteCardImages = promoteAll;
})();
